import React, { useMemo } from 'react';

import type { SmartLinkResponse } from '@atlaskit/linking-types';
import { useIntl } from '@atlassian/jira-intl';
import {
	SimpleInlineSmartLink,
	type Props,
} from '@atlassian/jira-issue-field-smart-link/src/ui/simple-inline-smart-link/index.tsx';
import restrictedMessages from '../../restricted/messages.tsx';
import { generatePlaceholderData } from './generate-placeholder-data.tsx';

/**
 * A wrapper around SimpleInlineSmartLink from @atlassian/jira-issue-field-smart-link to provide common placeholder data for Atlas Project links.
 *
 * Note: This is intended to replace the existing ../InlineSmartLink component. Once replaced, it will be renamed to InlineSmartLink.
 */
export const CommonInlineSmartLink = (props: Props) => {
	const { formatMessage } = useIntl();
	const { url, text } = props;

	const placeholderData = useMemo<SmartLinkResponse | undefined>(() => {
		if (!url) {
			return undefined;
		}

		return generatePlaceholderData(url, formatMessage(restrictedMessages.restrictedProject), text);
	}, [formatMessage, text, url]);

	return <SimpleInlineSmartLink {...props} isSimplifiedUI placeholderData={placeholderData} />;
};
